import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import {Grid, Paper} from "@material-ui/core";
import "../components/components.css"

import backgroundTwo from "../images/INQBAY_HP_2.png"
import ModuleLink from "../components/ModuleLink";
import footer_logos from "../images/footer_logos.png";

const useStyles = makeStyles((theme) => ({
    grid: {
        width: '100%',
        marginLeft: '400px',
        marginRight: '400px',
        background: '#0F5FAF'
    },

    paper: {
        padding: theme.spacing(0),
        textAlign: 'center',
        borderRadius: '5px',
        color: theme.palette.text.secondary,
        background: '#6AADE4',
    },
    paper1: {
        padding: theme.spacing(0),
        textAlign: 'center',
        borderRadius: '0px',
        color: theme.palette.text.secondary,
        background: '#6AADE4',
    },
    paper_left: {
        padding: theme.spacing(0),
        textAlign: 'left',
        borderRadius: '0px',
        color: theme.palette.text.primary,
        background: '#6AADE4',
        marginTop: '5px',
    },
    paper_center: {
        padding: theme.spacing(0),
        textAlign: 'center',
        borderRadius: '0px',
        color: theme.palette.text.secondary,
        background: '#6AADE4',
        marginTop: '5px',
    },

    mainIMG: {
        margin: '5px',
        width: '200px',
        height: '140px',
    },
    logoImg: {
        margin: '5px',
        width: '170px',
        height: '130px',
    },
    panelImg: {
        margin: '5px',
        width: '10px',
        height: '10px',
    },
    buttonGroup: {
        paddingLeft: '25%',
    },
    whiteText: {
        color: '#000',
    },
    Text: {
        color: '#FFF',
    },
    com: {
        margin: '50px',
    }
}));

const Index = () => {
    const classes = useStyles();

    return (
            <Grid item xs={12} md={12}>
                <Paper className={classes.paper_center} style={{
                    backgroundImage: "url(" + backgroundTwo + ")",
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat'
                }}>
                    <br/>
                    <h2 className={classes.Text}> Průvodce procesem transferu technologií </h2>

                    <br/>
                    <ModuleLink to={'/modul/1/'}>Je váš nápad inovativní</ModuleLink>
                    <br/>
                    <ModuleLink to={'/modul/2/'}>Má váš nápad komerční potenciál</ModuleLink>
                    <br/>
                    <ModuleLink to={'/modul/3/'}>Jak ochránit duševní vlastnictví</ModuleLink>
                    <br/>
                    <ModuleLink to={'/modul/4/'}>Jak podat přihlášku k vynálezu</ModuleLink>
                    <br/>
                    <ModuleLink to={'/modul/5/'}>Jak licencovat</ModuleLink>
                    <br/>
                    <ModuleLink to={'/modul/6/'}>Jak založit startup</ModuleLink>
                    <br/>
                    <ModuleLink to={'/modul/7/'}>Jak dostat výrobek na trh</ModuleLink>

                    <br/> <br/> <br/> <br/>
                </Paper>
                <Grid container
                      xs={12}
                      spacing={0}
                      direction="column"
                      alignItems="center"
                      justify="center"
                      style={({'backgroundColor': '#FFF', 'paddingTop': '1em'})}>
                    <img src={footer_logos} style={{width: '100%'}} />
                    <Grid xs={10} style={({ 'color': '#007ac3', 'textAlign': 'center'})}>
                        <span>
                            <br/>
                            Projekt č. CZ.02.2.69/0.0/0.0/16_014/0000650 – Podpora expertních kapacit pro efektivní transfer na ČVUT je spolufi nancován Evropskou Unií.
                            <br/>
                        </span>
                    </Grid>
                </Grid>
            </Grid>
    );
};
export default Index;
